import Result from "@/core/common/Result";
import { IIniciarVoucherUseCase } from "../ports/IniciarVoucherUsecase";
import { inject, injectable } from "inversify";
import "reflect-metadata";
import {
  type IIniciarVoucherGateway,
  iniciarVoucherGatewayDI
} from "../ports/IniciarVoucherGateway";

@injectable()
export class IniciarVoucherUsecaseAdapter implements IIniciarVoucherUseCase {
  @inject(iniciarVoucherGatewayDI)
  private readonly gateway!: IIniciarVoucherGateway;

  async sendDataVisualizacao(id: string, date: string): Promise<Result<void>> {
    const response = await this.gateway.sendDataVisualizacao(id, date);

    if (response.isFailure) return Result.fail(response.error);

    return Result.ok();
  }
}
